module.exports = __webpack_public_path__ + "img/chapter-2-thumb.28cd7b2c.jpg";